import React, {useContext, useEffect} from "react";
import {TravelQuotation} from "../../../../model/quotation";
import {ITravelQuotationContext, TravelQuotationContext} from "../../../../contexts/TravelQuotationContext";
import {Formik} from "formik";
import moment from "moment";
import {OutputValue} from "../../../../components/inputs/OutputValue";
import {strings} from "../../../../strings/strings";
import {travelAreaArray} from "../FastCalculationForm";
import "./index.scss";
import {TravelStepContext} from "../../../../contexts/TravelStepContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPen} from "@fortawesome/free-solid-svg-icons";
import {OutputLink} from "../../../../components/OutputLink";
import {TravelVerificationComponent} from "../../other/VerificationComponent";
import {packages} from "../SelectProgramForm";
import * as log from "../../../../utils/log";
import {LogFunctionalModule} from "../../../../utils/log";
import { useHotjar } from "../../../../utils/hooks/useHotjar";
import { EventTypeKey, useTabCloseTracking } from "../../../QuotationForm/forms/hooks/useTabCloseTracking";

interface TravelVerificationForm {
    onVerify: (quotation: TravelQuotation, paymentPageUrl: string) => void;
}

export const TravelVerificationForm = ({onVerify}: TravelVerificationForm) => {
    const {quotation, isQuotationEditable, type} = useContext<ITravelQuotationContext>(TravelQuotationContext);
    const {backStepListener} = useContext(TravelStepContext);
    const { trackHotjar } = useHotjar()

    const getTravelArea = (curTravelArea: string) => {
        return travelAreaArray.find(item => item.value === curTravelArea)?.label
    }

    const onBackStepClick = (quotation) => {
        const date = new Date();
        log.sendLog(date, LogFunctionalModule.STORE_TRAVEL, 'INFO',"VERIFICATION_FORM_BACK_HANDLER", [{quotation: quotation}], '')
        backStepListener(quotation)
    }

    const getProgramLabel = (program: string) => {
        return packages.find(item => item.value === program)?.title
    }

    useEffect(() => {
        let event = 'travel_information';
        console.log('Google Analytics Event = ' + event);
        // @ts-ignore
        window.dataLayer.push({'event': event});

        trackHotjar("confirm", type);
    }, []);

    const { email } = quotation?.travelWebContract?.primaryInsured || {};
    useTabCloseTracking(email, EventTypeKey.AbandonedTravel);

    return (
        <div className="travel-verification-form fluid container-fluid">
            <div className="travel-verification-form__info">
                <Formik initialValues={{
                    coverage: getTravelArea(quotation.travelWebContract.travelArea),
                    expiration: moment(quotation.travelWebContract.startDate).format('DD.MM.YYYY') + '-' + moment(quotation.travelWebContract.endDate).format('DD.MM.YYYY'),
                    totalPremium: quotation.totalPremium,
                    primaryInsuredFullName: '',
                    program: getProgramLabel(quotation.travelWebContract.travelPackage),
                    touristCount: quotation.travelWebContract.touristCount,
                    quotation
                }}
                        onSubmit={values => {
                        }}>
                    {formProps => (
                        <form onSubmit={formProps.handleSubmit} className="form">
                            <div className="travel-verification-form__info__general">
                                <div style={{gridArea: "title"}}>
                                    <h1>Страховий поліс</h1>
                                </div>

                                <div style={{gridArea: "total"}}>
                                    <OutputValue name={'totalPremium'}
                                                 label={strings.price}/>
                                </div>

                                <div style={{gridArea: "coverage"}}>
                                    <OutputValue name={'coverage'}
                                                 label={strings.coverage}/>
                                </div>

                                <div style={{gridArea: "program"}}>
                                    <OutputValue name={'program'}
                                                 label={strings.program}/>
                                </div>

                                <div style={{gridArea: "expiration"}}>
                                    <OutputValue name={'expiration'} label={strings.expiration}/>
                                </div>

                                <div style={{gridArea: "touristCount"}}>
                                    <OutputValue name={'touristCount'} label={strings.touristCountFull}/>
                                </div>
                            </div>

                            {
                                quotation.travelWebContract.persons.map((person, index) => {
                                    return (
                                        <div className="travel-verification-form__info__insured">
                                            <div style={{gridArea: "title"}}>
                                                <h1>{index === 0 && quotation.travelWebContract.payerIsPerson ? strings.insurerTourist : `${strings.tourist} ${quotation.travelWebContract.persons.length === 1 ? '' : index + 1}`}</h1>
                                            </div>

                                            <div style={{gridArea: "name"}}>
                                                <OutputValue name={'primaryInsuredFullName'}
                                                             outputValue={person.surname + ' ' + person.givenName}
                                                             label={strings.insuredFullName}/>
                                            </div>

                                            <div style={{gridArea: "documentNumber"}}>
                                                <OutputValue name={`quotation.travelWebContract.persons[${index}].documentNumber`}
                                                             label={strings.documentNumber}/>
                                            </div>

                                            <div style={{gridArea: "birth-date"}}>
                                                <OutputValue name={`quotation.travelWebContract.persons[${index}].birthDate`}
                                                             outputValue={moment(person.birthDate).format('DD.MM.YYYY')}
                                                             label={strings.insuredBirthDate}/>
                                            </div>

                                            {isQuotationEditable &&
                                                <div style={{gridArea: "edit"}} className="verification-form__info__insured__edit">
                                                    <OutputLink label={strings.edit}
                                                                id={'verificationForm-insured-btnEdit'}
                                                                icon={<FontAwesomeIcon icon={faPen as any}/>}
                                                                onClickListener={() => onBackStepClick(quotation)}/>
                                                </div>
                                            }

                                            <div style={{gridArea: "phone"}}>
                                                <OutputValue name={`quotation.travelWebContract.persons[${index}].mobileNumber`}
                                                             label={strings.phoneWithDots}/>
                                            </div>

                                            <div style={{gridArea: "address"}}>
                                                <OutputValue name={`quotation.travelWebContract.persons[${index}].address`}
                                                             label={strings.addressFull}/>
                                            </div>

                                            {index === 0 && quotation.travelWebContract.payerIsPerson ? <div style={{gridArea: "email"}}>
                                                <OutputValue name={'quotation.travelWebContract.primaryInsured.email'}
                                                             label={strings.insuredEmail}/>
                                            </div> : <></>}
                                        </div>
                                    )
                                })
                            }
                            {
                                !quotation.travelWebContract.payerIsPerson ? <div className="travel-verification-form__info__insured">
                                    <div style={{gridArea: "title"}}>
                                        <h1>{strings.insured}</h1>
                                    </div>

                                    <div style={{gridArea: "name"}}>
                                        <OutputValue outputValue={quotation.travelWebContract.primaryInsured.surname + ' ' + quotation.travelWebContract.primaryInsured.givenName}
                                                     name={'primaryInsuredFullName'}
                                                     label={strings.insuredFullName}/>
                                    </div>

                                    <div style={{gridArea: "documentNumber"}}>
                                        <OutputValue outputValue={moment(quotation.travelWebContract.primaryInsured.birthDate).format('DD.MM.YYYY')}
                                                     name={`quotation.travelWebContract.primaryInsured.birthDate`}
                                                     label={strings.insuredBirthDate}
                                        />
                                    </div>

                                    <div style={{gridArea: "birth-date"}}>
                                        <OutputValue name={`quotation.travelWebContract.primaryInsured.livingAddress.unstructured`}
                                                     outputValue={quotation.travelWebContract.primaryInsured.livingAddress.unstructured}
                                                     label={strings.addressFull}/>
                                    </div>

                                    {isQuotationEditable &&
                                        <div style={{gridArea: "edit"}} className="verification-form__info__insured__edit">
                                            <OutputLink label={strings.edit}
                                                        id={'verificationForm-insured-btnEdit'}
                                                        icon={<FontAwesomeIcon icon={faPen as any}/>}
                                                        onClickListener={() => onBackStepClick(quotation)}/>
                                        </div>
                                    }

                                    <div style={{gridArea: "phone"}}>
                                        <OutputValue name={`quotation.travelWebContract.primaryInsured.mobileNumber`}
                                                     outputValue={quotation.travelWebContract.primaryInsured.mobileNumber}
                                                     label={strings.phoneWithDots}/>
                                    </div>

                                    <div style={{gridArea: "address"}}>
                                        <OutputValue name={'quotation.travelWebContract.primaryInsured.email'}
                                                     outputValue={quotation.travelWebContract.primaryInsured.email}
                                                     label={strings.insuredEmail}/>
                                    </div>
                                </div> : <></>
                            }
                        </form>
                    )}
                </Formik>
            </div>
            <div className="travel-verification-form__verify">
                <TravelVerificationComponent onVerify={onVerify}/>
            </div>
        </div>
    )
};
